import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../data/drum';
export function Bonuses() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-39" data-mp="piy0if19jjgv">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-40" data-mp="avlaoe4farko">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-4" data-id="element-41" data-mp="at8uo6i86ra9">
          <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-42" data-mp="fsliatgx82dw">But there’s more!</p>
          <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-43" data-mp="1stz8ebjrvt1">
            5 bonuses <em className="text-red-700" data-id="element-44" data-mp="5tnll39cd2jt">at no extra cost</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-900/75" data-id="element-45" data-mp="3o3g0c60mldnj">
            Five extra resources come with your six volumes – so running your studio and teaching every
            lesson gets even easier.
          </p>
        </div>

        <ol className="border-t border-slate-900/15 lg:col-span-8" data-id="element-46" data-mp="1r934m0qt0omt">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid grid-cols-[2.5rem_1fr] gap-x-5 border-b border-slate-900/15 py-9 sm:grid-cols-[3.5rem_1fr] sm:gap-x-8" data-id="element-47" data-mp="3ie6ipjlba5wq" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700 sm:text-6xl" aria-hidden="true" data-id="element-48" data-mp="3df3ajqa1bjkj">
                {index + 1}
              </span>
              <div data-id="element-49" data-mp="3n4wm4ra6fyos">
                <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3" data-id="element-50" data-mp="3n6g5iqr4qpus">
                  <h3 className="max-w-md font-serif text-2xl leading-tight text-slate-900 sm:text-3xl" data-id="element-51" data-mp="2zgdf0f2v5rya">
                    <span className="sr-only" data-id="element-52" data-mp="2ui24010u1beh">Bonus {index + 1} – </span>
                    {bonus.title}
                  </h3>
                  <span className="shrink-0 -rotate-3 rounded border-2 border-red-700 px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-red-700" data-id="element-53" data-mp="38dw2rr7w6kdv">
                    Included
                  </span>
                </div>
                <p className="mt-3 max-w-xl leading-relaxed text-slate-900/75" data-id="element-54" data-mp="irgbd0ulel4i">{bonus.text}</p>
                <ul className="mt-4 grid max-w-xl gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-55" data-mp="3cjfy7bd4mnie">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-slate-900/75" data-id="element-56" data-mp="3hh81f1j81w1w">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-57" data-mp="3ljcrxredickb" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 max-w-xl font-serif text-lg italic leading-snug text-red-700" data-id="element-58" data-mp="2tsyiq8hb1oez">
                  {bonus.benefit}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}